import React from 'react';
import { FadeIn } from './FadeIn';
import { Download, MessageSquareText, PowerOff } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Download size={32} data-id="element-107" />,
    title: 'Paso 1',
    desc: 'Descargás la guía y detectás tus "puntos de fuga" de energía.'
  }, {
    icon: <MessageSquareText size={32} data-id="element-108" />,
    title: 'Paso 2',
    desc: 'Aplicás los guiones de comunicación blindada en tu primer mail de mañana.'
  }, {
    icon: <PowerOff size={32} data-id="element-109" />,
    title: 'Paso 3',
    desc: 'Ejecutás el ritual de salida para recuperar tu tiempo libre de verdad.'
  }];
  return <section className="bg-light-bg text-text-light py-20 md:py-28" data-id="element-110">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-111">
        <FadeIn data-id="element-112">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-16 text-primary-dark" data-id="element-113">
            ¿Cómo funciona?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-114">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-accent/20 z-0" data-id="element-115"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={0.2 * index} className="relative z-10" data-id="element-116">
              <div className="flex flex-col items-center text-center group" data-id="element-117">
                <div className="w-24 h-24 rounded-full bg-white border-4 border-light-bg shadow-lg flex items-center justify-center text-accent mb-6 transition-transform duration-300 group-hover:scale-110 group-hover:bg-accent group-hover:text-white" data-id="element-118">
                  {step.icon}
                </div>
                <h3 className="font-serif text-2xl font-bold text-primary-dark mb-4" data-id="element-119">
                  {step.title}
                </h3>
                <p className="text-text-muted text-lg leading-relaxed max-w-xs" data-id="element-120">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}